var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { _transformProject } from '@freelancer/datastore/projects';
import { transformSkill } from '@freelancer/datastore/skills';
import { transformLocation } from '@freelancer/datastore/users/users-location.transformers';
// Transforms what the backend returns into a format your components can consume
// Should only be called in this collection's reducer
export function transformProjectViewProjects(project, allSelectedBids) {
    return __assign(__assign({}, _transformProject(project, allSelectedBids)), { 
        // Extra things for freelancer pvp
        attachments: (project.attachments || []).map(function (attachment) {
            return transformProjectAttachment(attachment);
        }), canPostReview: project.can_post_review || {}, description: project.description, location: project.location
            ? transformLocation(project.location)
            : undefined, true_location: project.true_location
            ? transformLocation(project.true_location)
            : undefined, qualifications: project.qualifications
            ? project.qualifications.map(transformQualification)
            : [], jobs: (project.jobs || []).map(transformSkill), ndaDetails: project.nda_details
            ? transformNDADetails(project.nda_details)
            : { signatures: [] }, displayLocation: transformDisplayedLocation(project.true_location || project.location), localDetails: project.local_details
            ? transformProjectLocalDetails(project.local_details)
            : undefined, equipment: project.equipment });
}
// exactly the same as transformProjectViewProjects just with less required fields
export function transformProjectViewProjectsPush(projectIn) {
    // add stuff we might be missing from API
    var project = __assign(__assign({}, projectIn), { bid_stats: { bid_count: 0 }, time_submitted: projectIn.time_submitted
            ? projectIn.time_submitted * 1000
            : Date.now() });
    return transformProjectViewProjects(project, []);
}
function transformProjectAttachment(attachment) {
    return {
        id: attachment.id,
        filename: attachment.filename,
        timeSubmitted: (attachment.time_submitted || 0) * 1000,
        url: "https://" + attachment.url,
        accessHash: attachment.access_hash,
        contentType: attachment.content_type,
    };
}
export function transformQualification(qualification) {
    return {
        id: qualification.id,
        description: qualification.description,
        iconName: qualification.icon_name,
        iconUrl: qualification.icon_url,
        level: qualification.level,
        name: qualification.name,
        scorePercentage: qualification.score_percentage,
        type: qualification.type,
        userPercentile: qualification.user_percentile,
    };
}
function transformNDADetails(ndaDetails) {
    return {
        hiddenDescription: ndaDetails.hidden_description,
        signatures: ndaDetails.signatures
            ? ndaDetails.signatures.map(transformNDASignatures)
            : [],
    };
}
function transformNDASignatures(signatures) {
    if (signatures.time_signed === undefined) {
        throw Error("NDA signature does not have time signed");
    }
    if (signatures.project_id === undefined) {
        throw Error("NDA signature does not have project id");
    }
    if (signatures.user_id === undefined) {
        throw Error("NDA signature does not have user id");
    }
    return {
        timeSigned: signatures.time_signed * 1000,
        projectId: signatures.project_id,
        userId: signatures.user_id,
    };
}
export function transformDisplayedLocation(location) {
    if (location && location.full_address) {
        return location.full_address;
    }
    if (location && location.country) {
        if (location.administrative_area && location.city) {
            return location.city + ", " + location.administrative_area + ", " + location.country.name;
        }
        if (location.city) {
            return location.city + ", " + location.country.name;
        }
        if (location.administrative_area) {
            return location.administrative_area + ", " + location.country.name;
        }
        return location.country.name;
    }
    return undefined;
}
export function transformDisplayedLocationOnUpdate(location) {
    if (location && location.fullAddress) {
        return location.fullAddress;
    }
    if (location && location.country) {
        if (location.administrativeArea && location.city) {
            return location.city + ", " + location.administrativeArea + ", " + location.country.name;
        }
        if (location.city) {
            return location.city + ", " + location.country.name;
        }
        if (location.administrativeArea) {
            return location.administrativeArea + ", " + location.country.name;
        }
        return location.country.name;
    }
    return '';
}
export function transformProjectLocalDetails(projectLocalDetails) {
    return {
        date: projectLocalDetails.date || undefined,
        endLocation: projectLocalDetails.end_location
            ? transformLocation(projectLocalDetails.end_location)
            : undefined,
        displayEndLocation: transformDisplayedLocation(projectLocalDetails.end_location),
    };
}
export function transformProjectViewProjectsUpdate(delta) {
    return __assign(__assign({}, delta), { true_location: delta.location, localDetails: {
            date: delta.localDetails ? delta.localDetails.date : undefined,
            endLocation: delta.localDetails
                ? delta.localDetails.endLocation
                : undefined,
            displayEndLocation: transformDisplayedLocationOnUpdate(delta.localDetails ? delta.localDetails.endLocation : undefined) || undefined,
        }, displayLocation: transformDisplayedLocationOnUpdate(delta.true_location || delta.location || undefined) || undefined, equipment: delta.equipment || undefined });
}
